(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["before-product-card"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bia-card-gallery')){
  customElements.define('bia-card-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.viewportObserver=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.viewportObserver.disconnect();this.initialize()}},{rootMargin:'250px'});this.viewportObserver.observe(this);
    }
    initialize(){
      this.main=this.querySelector('.bia-card__img');this.alternate=this.querySelector('.bia-card__alternate');this.dots=this.querySelector('.bia-card__photo-dots');this.link=this.querySelector('a');
      if(!this.main||!this.link)return;
      try{this.photos=JSON.parse(this.querySelector('[data-card-photos]').textContent)}catch{return}
      this.normalize=src=>{try{const u=new URL(src,location.href);return u.pathname}catch{return src}};
      this.sync=()=>{
        const first=this.photos.find(p=>this.normalize(p.src)===this.normalize(this.main.src));
        this.group=first?[first,...this.photos.filter(p=>p!==first&&p.color===first.color)]:[];
        if(first&&!first.color)this.group=[first];
        this.index=0;this.alternate.hidden=true;this.dots.replaceChildren();this.dots.hidden=this.group.length<2;
        this.group.forEach((p,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',`View mockup ${i+1} of ${this.group.length}`);b.setAttribute('aria-pressed',String(i===0));b.addEventListener('click',()=>this.show(i));this.dots.append(b)});
      };
      this.show=i=>{if(!this.group.length)return;this.index=(i+this.group.length)%this.group.length;const p=this.group[this.index];if(this.index){this.alternate.src=p.src;this.alternate.alt=p.alt;this.alternate.hidden=false}else this.alternate.hidden=true;Array.from(this.dots.children).forEach((b,n)=>b.setAttribute('aria-pressed',String(n===this.index)))};
      this.updateTouchMode=()=>{
        this.inProductRow=false;
        for(let parent=this.parentElement;parent&&parent!==document.body;parent=parent.parentElement){
          const overflow=getComputedStyle(parent).overflowX;
          if((overflow==='auto'||overflow==='scroll')&&parent.scrollWidth>parent.clientWidth+1){this.inProductRow=true;break}
        }
        this.style.touchAction=this.inProductRow?'auto':'pan-y pinch-zoom';
      };
      this.updateTouchMode();this.mediaQuery=matchMedia("(max-width:989px)");this.mediaQuery.addEventListener("change",this.updateTouchMode);
      this.sync();this.observer=new MutationObserver(this.sync);this.observer.observe(this.main,{attributes:true,attributeFilter:['src']});
      this.previewBack=e=>{if(e.pointerType==='touch'||this.group.length<2||e.target.closest('.bia-card__photo-dots'))return;const back=this.group.findIndex((p,i)=>i>0&&/\bback\b/i.test(p.alt));const target=back>0?back:1;if(this.index!==target)this.show(target)};
      this.addEventListener('pointerenter',this.previewBack);
      this.addEventListener('pointermove',this.previewBack);
      this.addEventListener('pointerleave',e=>{if(e.pointerType!=='touch')this.show(0)});
      this.link.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'&&!this.inProductRow){this.start={x:e.clientX,y:e.clientY};this.suppress=false}});
      this.link.addEventListener('pointerup',e=>{if(!this.start)return;const dx=e.clientX-this.start.x,dy=e.clientY-this.start.y;this.start=null;if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)*1.3&&this.group.length>1){this.show(this.index+(dx<0?1:-1));this.suppress=true}});
      this.link.addEventListener('pointercancel',()=>{this.start=null});
      this.link.addEventListener('click',e=>{if(this.suppress){e.preventDefault();e.stopPropagation();this.suppress=false}},true);
    }
    disconnectedCallback(){this.observer?.disconnect();this.viewportObserver?.disconnect();this.mediaQuery?.removeEventListener("change",this.updateTouchMode);this.ready=false}
  });
}
  } catch(e) { console.error(e); }
})();

})();
